/* Tribe — page d'accueil : interactions des sections tr-* */
(function () {
  if (window.__trHome) return;
  window.__trHome = true;

  var canHover = window.matchMedia('(hover: hover)').matches;
  var LABEL_SOUND_ON = 'Son';
  var LABEL_SOUND_OFF = 'Muet';

  function cardVideo(card, play) {
    var v = card.querySelector('video');
    if (!v) return;
    if (play) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      card.classList.add('is-playing');
    } else {
      v.pause();
      card.classList.remove('is-playing');
    }
  }
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('.tr-card[data-hover-video]');
      if (card && !card.contains(e.relatedTarget)) cardVideo(card, true);
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.tr-card[data-hover-video]');
      if (card && !card.contains(e.relatedTarget)) cardVideo(card, false);
    });
  }

  function observeVideos(root) {
    if (!('IntersectionObserver' in window)) return;
    var sel = '.tr-card--autoplay video, .tr-vid video' + (canHover ? '' : ', .tr-card[data-hover-video] video');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          v.muted = v.dataset.unmuted ? v.muted : true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          var c = v.closest('.tr-card'); if (c) c.classList.add('is-playing');
        } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    (root || document).querySelectorAll(sel).forEach(function (v) { io.observe(v); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var arrow = t.closest && t.closest('[data-tr-slide]');
    if (arrow) {
      var slider = arrow.closest('.tr-slider');
      var track = slider && slider.querySelector('.tr-slider__track');
      if (track) {
        var dir = arrow.getAttribute('data-tr-slide') === 'next' ? 1 : -1;
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 20 : track.clientWidth;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    var tab = t.closest && t.closest('.tr-tab');
    if (tab) {
      var wrap = tab.closest('[data-tr-reviews]');
      var key = tab.getAttribute('data-tab');
      wrap.querySelectorAll('.tr-tab').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      wrap.querySelectorAll('.tr-review').forEach(function (r) {
        var tabs = (r.getAttribute('data-tabs') || '').split('|');
        r.hidden = !(key === '*' || tabs.indexOf(key) > -1);
      });
      return;
    }

    var open = t.closest && t.closest('[data-tr-video-open]');
    if (open) {
      var sec = open.closest('.tr');
      var dlg = sec && sec.querySelector('dialog.tr-modal');
      var tpl = sec && sec.querySelector('template[data-tr-video]');
      if (dlg && tpl) {
        var holder = dlg.querySelector('.tr-modal__inner');
        holder.querySelectorAll('iframe,video').forEach(function (n) { n.remove(); });
        holder.appendChild(tpl.content.cloneNode(true));
        var v = holder.querySelector('video');
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      }
      return;
    }

    if (t.closest && (t.closest('[data-tr-video-close]') || t.matches('dialog.tr-modal'))) {
      var d = t.closest('dialog.tr-modal');
      if (d) {
        d.querySelectorAll('iframe,video').forEach(function (n) { n.remove(); });
        if (d.close) d.close(); else d.removeAttribute('open');
      }
      return;
    }

    var mute = t.closest && t.closest('.tr-vid__mute');
    if (mute) {
      var vid = mute.parentElement.querySelector('video');
      if (vid) {
        vid.muted = !vid.muted;
        vid.dataset.unmuted = vid.muted ? '' : '1';
        mute.textContent = vid.muted ? LABEL_SOUND_ON : LABEL_SOUND_OFF;
        if (!vid.muted) {
          document.querySelectorAll('.tr-vid video').forEach(function (o) { if (o !== vid) { o.muted = true; o.dataset.unmuted = ''; var b = o.parentElement.querySelector('.tr-vid__mute'); if (b) b.textContent = LABEL_SOUND_ON; } });
        }
      }
    }
  });

  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.tr-modal')) {
      e.target.querySelectorAll('iframe,video').forEach(function (n) { n.remove(); });
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { observeVideos(); });
  else observeVideos();

  document.addEventListener('shopify:section:load', function (e) { observeVideos(e.target); });
})();
